// src/hooks/useGetDetectors.js
import { useState, useEffect, useRef } from 'react';
import { API_URL } from '../config';
import { authFetch } from '../utils';

function useGetDetectors() {
  const [detectors, setDetectors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const firstLoad = useRef(true);

  useEffect(() => {
    let isMounted = true;

    const fetchDetectors = () => {
      authFetch(`${API_URL}smoke-detectors/facility/paterna`)
        .then((res) => {
          if (!res.ok) throw new Error('Error al obtener detectores');
          return res.json();
        })
        .then((data) => {
          if (!isMounted) return;

          setDetectors(data);
          setError(null);
          setIsLoading(false);

          firstLoad.current = false;
        })
        .catch((err) => {
          if (!isMounted) return;

          console.error("Error al obtener detectores:", err);

          if (firstLoad.current) {
            setError(err);
            setIsLoading(false);
          }

          // Si no es la primera carga:
          // - NO tocamos detectors
          // - NO mostramos error
        });
    };

    fetchDetectors();
    const interval = setInterval(fetchDetectors, 10000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, []);

  return { detectors, setDetectors, isLoading, error };
}

export default useGetDetectors;

